import { typo, Button, Tooltip, transitionCss } from '@cycle-app/ui';
import { InfoIconOutline } from '@cycle-app/ui/icons';
import { Color } from '@cycle-app/ui/theme/baseColors';
import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const StyledInfoIconOutline = styled(InfoIconOutline)`
  height: 12px;
  width: 12px;
`;

export const PricingBox = styled.div`
  border-radius: 16px;
  border: 1px solid ${p => p.theme.colors.border.primary};
  background-color: ${p => p.theme.colors.ugradeLayout.mainBox.bg};
  margin-top: 42px;
  position: relative;
  z-index: 2;
`;

export const Pricing = styled.div`
  margin-top: 24px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 16px;
`;

export const PricingHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const PriceTooltip = styled(Tooltip)`
  text-align: center;
`;

export const PriceTag = styled.span`
  ${typo.headerLarge}
  font-size: 32px;
`;

export const PriceInfo = styled.div`
  [data-popover] {
    display: flex;
    align-items: center;
  }
`;

export const PriceSymbol = styled.sup`
  ${typo.headerLarge}
  color: ${p => p.theme.colors.text.secondary};
  font-weight: 400;
  margin-right: 2px;
  vertical-align: text-top;
`;

export const PricePeriod = styled.p`
  ${typo.body400}
  color: ${Color.Grey700};
  margin-top: 3px;
`;

interface UpgradeButtonProps { $isCurrent?: boolean }

export const UpgradeButton = styled(Button) <UpgradeButtonProps>`
  margin-top: 20px;
  width: 100%;
`;

export const PricingDiscount2 = styled.div`
  opacity: 0;
  ${transitionCss(['opacity'])}
  color: ${p => p.theme.colors.ugradeLayout.pricingToggle.discount.color};
  background: ${p => p.theme.colors.ugradeLayout.pricingToggle.discount.bg};
  ${typo.caption500}
  padding: 0px 4px;
  border-radius: 4px;
  position: absolute;
  left: -12px;
  transform: translate(-100%, 0);
  white-space: nowrap;
`;

export const PricingFrequencyLabel2 = styled.div`
  color: ${p => p.theme.colors.text.secondary};
  ${typo.caption500}
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PricingFrequencyToggle = styled.button`
  position: absolute;
  color: ${p => p.theme.colors.ugradeLayout.pricingToggle.switchToggle.color};
  ${typo.caption500}
  height: calc(100% - 2px);
  padding: 0 16px;
  background-color: ${p => p.theme.colors.ugradeLayout.pricingToggle.switchToggle.bg};
  border: 1px solid ${p => p.theme.colors.ugradeLayout.pricingToggle.switchToggle.border};
  left: 0;
  margin: 1px;
  ${transitionCss(['transform', 'left'])}
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08)) drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.02)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.09));
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PricingFrequency2 = styled.div<{ $isAnnual: boolean }>`
  background-color: ${p => p.theme.colors.ugradeLayout.pricingToggle.switch.bg};
  position: relative;
  width: 150px;
  height: 40px;
  border-radius: 10px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 21px auto;
  cursor: pointer;

  ${p => p.$isAnnual && css`
    ${PricingDiscount2} {
      opacity: 1;
    }
  `}

  ${p => !p.$isAnnual && css`
    ${PricingFrequencyToggle} {
      left: 100%;
      transform: translate(-100%, 0);
    }
  `}
`;

export const Bottom = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
`;
